import { useDispatch, useSelector } from "react-redux";
import { addSemester, getSemester } from "../store/semester";

export default function useSemester() {
  const dispatch = useDispatch();
  const semesterData = useSelector(
    (state) => state.semester.data?.semester || []
  );
  const loadingSem = useSelector((state) => state.semester.loading);
  const addSemesterAction = (params) => dispatch(addSemester(params));
  const getSemesterAction = (params) => dispatch(getSemester(params));

  return {
    // data
    semesterData,
    loadingSem,
    // actions
    getSemesterAction,
    addSemesterAction,
  };
}
